import { Reveal } from "../components/Reveal";
import { STEPS } from "../data/content";
import { useUI } from "../context/UIContext";
import { ArrowRight } from "lucide-react";

export const SoFunktioniert = () => {
  const { openUpload } = useUI();
  return (
    <section className="bg-white py-24 sm:py-32 border-t border-slate-100" data-testid="so-funktioniert-section">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="max-w-2xl mb-20">
          <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">So funktioniert es</p>
          <h2 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-navy-900 leading-[1.05]">
            In vier Schritten zu Ihrem <span className="font-serif italic text-blue-700">besten</span> Tarif.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 rounded-3xl overflow-hidden border border-slate-200">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div className="group relative bg-white p-8 sm:p-10 h-full min-h-[280px] hover:bg-blue-700 transition-colors duration-500" data-testid={`step-${s.n}`}>
                <span className="absolute right-6 top-4 text-7xl font-heading font-semibold text-slate-100 group-hover:text-white/10 transition-colors duration-500 select-none">
                  {s.n}
                </span>
                <div className="relative z-10 flex flex-col h-full">
                  <span className="h-1.5 w-10 rounded-full bg-blue-600 mb-6" />
                  <h3 className="text-xl font-heading text-navy-900 group-hover:text-white transition-colors duration-500 mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-slate-500 group-hover:text-slate-300 leading-relaxed transition-colors duration-500">
                    {s.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-6">
          <button
            onClick={openUpload}
            className="group rounded-full bg-blue-700 hover:bg-blue-600 text-white px-8 py-4 font-medium transition-colors duration-300 flex items-center gap-2"
            data-testid="steps-cta-btn"
          >
            Jetzt EnergieCheck starten
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <p className="text-sm text-slate-400">✓ Kostenlos & unverbindlich · 🔒 DSGVO-konform · Angebot in 24 h</p>
        </div>
      </div>
    </section>
  );
};
